import { Table, Row, Col, Space, Select, message } from 'antd';
import React, { Component } from 'react';
import styled from 'styled-components';
import actionIcon from '../../assets/icons/actiona.svg';
import moment from 'moment';
import { AuthorizeRoleService } from '../../services/api';
import eyeIcon from '../../assets/icons/eye.svg';
import EditPayslipModal from '../../components/payslip/editPayslipModal';
import { getUserPic } from '../../services/image';

const ContentBox = styled.div`
  background: ${(props) => (props.nc ? 'none' : '#ffffff')};
  box-sizing: border-box;
  padding-left: 3%;
  padding-right: 3%;
  display: flex;
  width: auto;
  min-height: calc(100vh - 200px);
`;

const ProjectTable = styled(Table)`
  & .ant-table.ant-table-small .ant-table-thead > tr > th {
    font-size: 16px;
    font-weight: bold;
    background-color: white;
    padding-bottom: 20px;
  }

  &.table-striped-rows tr > th {
    background-color: #ffffff;
  }
  &.table-striped-rows tr > td {
    height: 50px;
  }
  .ant-table.ant-table-small .ant-table-tbody > tr > td {
    padding: 6px 8px;
  }
`;

const Selectdata = styled(Select)`
  border-radius: 5px;
`;

const TableText = styled.div`
  color: ${(props) => (props.name ? '#004368' : '#737373')};
  font-size: 1em;
  font-weight: ${(props) =>
    props.title ? '600' : props.isKey ? '500' : '300'};
  font-family: Kanit;
  line-height: 22px;
  text-align: left;
`;

const Text = styled.div`
  color: #232323;
  font-size: 16px;
  font-weight: 500;
  font-family: Kanit;
`;

class PayslipPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      mainData: null,
      isLoading: false,
      editModalVisible: false,
      record: null,
    };
  }

  componentDidMount = () => {
    this.fetchPayslipHistory();
  };

  editModalClose = () => {
    this.setState({
      editModalVisible: false,
      record: null,
    });
  };

  editModalOpen = async (record) => {
    record = await getUserPic(record);
    this.setState({
      editModalVisible: true,
      record: record,
    });
  };

  fetchPayslipHistory = () => {
    this.setState({
      isLoading: true,
    });
    AuthorizeRoleService.getAllPayslipHistory(
      ({ data }) => {
        this.setState({
          data: data,
          mainData: data,
          isLoading: false,
        });
      },
      (response) => {
        this.setState({
          isLoading: false,
        });

        if (response) message.error(`Error: ${response.data.message}`);
      },
    );
  };

  onStatusTypeFilterChange = (value) => {
    if (value === 'All') {
      this.setState({
        data: this.state.mainData,
      });
    } else {
      this.setState({
        data: this.state.mainData.filter(
          (record) => record.requestStatusName === value,
        ),
      });
    }
  };

  render() {
    const defaultStringCompare = (property) => (a, b) =>
      a[property].localeCompare(b[property]);

    const columns = [
      {
        title: 'TYPE',
        dataIndex: 'payslipName',
        align: 'center',
        sorter: defaultStringCompare('payslipName'),
        render: (value) => <TableText>{value}</TableText>,
      },
      {
        title: 'NAME',
        dataIndex: 'firstnameEn',
        align: 'center',
        sorter: defaultStringCompare('firstnameEn'),
        render: (key, record) => (
          <TableText>{`${record.firstnameEn} ${record.lastnameEn}`}</TableText>
        ),
      },
      {
        title: 'DATE',
        dataIndex: 'createDatetime',
        width: '250px',
        align: 'center',
        sorter: defaultStringCompare('createDatetime'),
        render: (value) => (
          <TableText style={{ textAlign: 'center' }}>
            {moment(value).format('YYYY/MM/DD')}
          </TableText>
        ),
      },
      {
        title: 'STATUS',
        dataIndex: 'requestStatusName',
        width: '180px',
        align: 'center',
        sorter: defaultStringCompare('requestStatusName'),
        render: (value) => (
          <TableText style={{ textAlign: 'center' }}>
            {value == 'Pending' ? (
              <label style={{ color: '#FFAB4F' }}>Pending</label>
            ) : value === 'Approved' ? (
              <label style={{ color: '#3C8618' }}>Approved</label>
            ) : value === 'Rejected' ? (
              <label style={{ color: '#668EA4' }}>Rejected</label>
            ) : value === 'Canceled by Approver' ? (
              <label style={{ color: '#D62923' }}>Canceled by Approver</label>
            ) : (
              <label style={{ color: '#F37370' }}>Canceled by User</label>
            )}
          </TableText>
        ),
      },
      {
        title: 'ACTION',
        align: 'center',
        width: '180px',
        render: (key, record) => (
          <a onClick={() => this.editModalOpen(record)}>
            {record.requestStatusName === 'Pending' ? (
              <img src={actionIcon} />
            ) : (
              <img src={eyeIcon} />
            )}
          </a>
        ),
      },
    ];
    return (
      <div style={{ width: 'auto' }}>
        <Space
          direction="vertical"
          size="middle"
          style={{
            width: '100%',
            padding: '20px 3%',
            backgroundColor: '#ffffff',
          }}
        >
          <Row justify="space-between" gutter={[16, 16]}>
            <Col
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Text>All Salary Certificate</Text>
            </Col>
            <Col>
              <Selectdata
                defaultValue={'All'}
                style={{ width: 208 }}
                onChange={this.onStatusTypeFilterChange}
              >
                <Select.Option value="All">All Status</Select.Option>
                <Select.Option value="Approved">Approved</Select.Option>
                <Select.Option value="Pending">Pending</Select.Option>
                <Select.Option value="Rejected">Rejected</Select.Option>
                <Select.Option value="Canceled by User">
                  Canceled by User
                </Select.Option>
                <Select.Option value="Canceled by Approver">
                  Canceled by Approver
                </Select.Option>
              </Selectdata>
            </Col>
          </Row>
        </Space>
        <ContentBox>
          <ProjectTable
            className="table-striped-rows"
            columns={columns}
            scroll={{ x: 300 }}
            dataSource={this.state.data}
            style={{ width: '100%' }}
            size="small"
            loading={this.state.isLoading}
            pagination={{
              position: ['bottomRight'],
              pageSizeOptions: [10, 20, 30, 40],
              showSizeChanger: true,
            }}
          />
        </ContentBox>
        <EditPayslipModal
          open={this.state.editModalVisible}
          onCancel={this.editModalClose}
          onFetch={this.fetchPayslipHistory}
          record={this.state.record}
        />
      </div>
    );
  }
}

export default PayslipPage;
